import axios from "../config/axios";
const partnerBilling = {
    modifyRefileRule: (data) =>
        axios
        .post(`/billing/PartnerBilling/modifyRefileRule`,data)
        .then((resp) => resp.data)
        .catch((err) => console.log(err))
}
export default partnerBilling;